<!-- Featured Buttons -->
<div class="row">
    <div class="col-md-12">
        <div class="col-md-4">
            <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print1()" placement="bottom" [disabled]="vehicleChecksCount < 1" ngbTooltip="Print List">
                <i class="fa fa-lg fa-print"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
            </button>

            <div class="btn-group mr-1">
                <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="vehicleChecksCount < 1">
                    <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                </button>
                <div class="dropdown-menu fs-12">
                        <a (click)="vehicleCheck_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                        <a (click)="vehicleCheck_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                        <a (click)="vehicleCheck_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                </div>
            </div>

            <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                <i class="fa fa-lg fa-filter"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
            </button>

            <div class="btn-group mb-1">
                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="sr-only">Toggle Dropdown</span>
                    <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                </button>
                <div class="dropdown-menu fs-12" style="width: 150px;">
                    <div class="col-md-12 mb-3 fs-12">
                       <input type="checkbox" [(ngModel)]="showDate"> Date<br />
                       <input type="checkbox" [(ngModel)]="showEtag"> Etag Number<br />
                       <input type="checkbox" [(ngModel)]="showRego"> Rego<br />
                       <input type="checkbox" [(ngModel)]="showType"> Type<br />
                       <input type="checkbox" [(ngModel)]="showDriver"> Driver<br />
                       <input type="checkbox" [(ngModel)]="showStatus"> Status<br />
                       <input type="checkbox" [(ngModel)]="showFile"> File<br /> 
                    </div>
                </div>
            </div>

        </div>
    </div>
</div><!-- End of Featured Buttons -->

<br />
<!-- Search Vehicle Checks List -->
<div class="row">
    <div style="margin-left: 18px;"></div>
    <div class="col-md-8">
        <div widget class="card border-0 box-shadow" *ngIf="showFilters">
            <div class="card-header border-0 text-muted">
                <h5 class="mb-0">Search Vehicle Checks:</h5>
                <div class="widget-controls"> 
                    <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                </div>  
            </div>
            <div class="card-body card-header pt-0 widget-body">
                <div class="row">
                    <div class="form-group col-md-4">
                        <label>Date:</label> 
                        <input type="date" class="form-control form-control-sm" [(ngModel)]="filterVDate" (change)="updateFilter()">
                    </div>
                    <div class="form-group col-md-4">
                        <label>Driver:</label> 
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="filterVDriver" (keyup)="updateFilter()"> 
                    </div>
                    <div class="form-group col-md-4">
                        <label>REGO:</label> 
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="filterVRego" (keyup)="updateFilter()"> 
                    </div>
                </div>
                <div class="row" *ngIf="!isFilterEmpty">
                    <div class="col-md-12">
                        <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters()">
                                <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-filter"></i></span>
                                <span >Reset Filters</span>
                        </button> &nbsp;
                    </div>
                </div>                                  
            </div>
        </div>
    </div>
</div><!-- End of Search Vehicle Checks List -->

<br *ngIf="showFilters" />
<!-- VEHICLE CHECKS TABLE -->
<div class="card-body pt-0 widget-body">
    <ngx-loading [show]="loadingIndicator"></ngx-loading>
    <ngx-datatable  *ngIf="vehicleChecksCount > 0 && !loadingIndicator"
        [loadingIndicator]="loadingIndicator"
        class="material"
        [rows]="rows1"
        [columnMode]="'force'"
        [columns]="columns"
        [footerHeight]="40"
        [rowHeight]="'auto'"
        [limit]="10"
        [selected]="selected"
        [selectionType]="'single'"
        >

        <ngx-datatable-column name="Date" prop="date_done"  headerClass="header" [width]="120" *ngIf="showDate">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ (value !== null && value != '0000-00-00') ? (value | date: 'dd MMM yyyy') : "No Date"  }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Etag No" prop="fleet_etag_no"  headerClass="header" [width]="120" *ngIf="showEtag"></ngx-datatable-column>

        <ngx-datatable-column name="REGO" prop="fleet_rego"  headerClass="header" [width]="120" *ngIf="showRego"></ngx-datatable-column>

        <ngx-datatable-column name="Type" prop="fleet_type_name"  headerClass="header" [width]="120" *ngIf="showType"></ngx-datatable-column>

        <ngx-datatable-column *ngIf="showDriver">
            <ng-template let-column="column" ngx-datatable-header-template >
                Driver
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.driver_first_name}} {{row.driver_last_name}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Status" prop="is_compliant"  headerClass="header"  [width]="120" *ngIf="showStatus">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value == 1 ? "Compliant" : "Non-Compliant"  }}
            </ng-template>
        </ngx-datatable-column>
        
        <ngx-datatable-column name="File" prop="file"  headerClass="header" [width]="420" *ngIf="showFile">
            <ng-template let-value="value" ngx-datatable-cell-template>
                <a href="{{fileStoragePath}}/compliance/{{value}}" target="_new">{{value}}</a>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div><!-- END OF VEHICLE CHECKS TABLE -->

<!-- START PRINT-->
<div id="print-section1" style="display:none">
        
        <table style="width:100%">
                <tr>
                  <th align="left" *ngIf="showDate">DATE</th>
                  <th align="left" *ngIf="showEtag">ETAG NO.</th>
                  <th align="left" *ngIf="showRego">REGO</th>
                  <th align="left" *ngIf="showType">TYPE</th>
                  <th align="left" *ngIf="showDriver">DRIVER</th>
                  <th align="left" *ngIf="showStatus">STATUS</th>
                  <th align="left" *ngIf="showFile">FILE</th>    
                </tr>
                <tr *ngFor="let row of rows1">
                <td *ngIf="showDate">{{ (row.date_done !== null && row.date_done != '0000-00-00') ? (row.date_done | date: 'dd MMM yyyy') : "No Date"  }}</td>
                  <td *ngIf="showEtag">{{row.fleet_etag_no}}</td>
                  <td *ngIf="showRego">{{row.fleet_rego}}  </td>
                  <td *ngIf="showType">{{row.fleet_type_name}}</td>
                  <td *ngIf="showDriver">{{row.driver_first_name}} {{row.driver_last_name}}</td>
                  <td *ngIf="showStatus">{{ row.is_compliant == 1 ? "Compliant" : "Non-Compliant"  }}</td>
                  <td *ngIf="showFile"><a href="{{fileStoragePath}}/compliance/{{row.file}}" target="_new">{{row.file}}</a></td>
                </tr>
        </table>
</div>
<!-- END PRINT -->